import { Outlet } from 'react-router-dom'
import DashHeader from './DashHeader'
import DashFooter from './DashFooter'

const DashLayout = () => {
    return (
        <div className="d-flex flex-column min-vh-100 bg-dark">
            <DashHeader />
            <div className="dash-container flex-grow-1 py-4">
                <Outlet />
            </div>
            <DashFooter />
        </div>
    )
}
export default DashLayout
